export enum Routes {
  FleetCascoRouter = "*",
  CascoExpirySearchPageRouter = "/fleet/casco-expiry/search",
}
